import useStyles from './CustomKanbanColumnEmpty.styles';

export function CustomKanbanColumnEmpty({ text = '' }) {
  const componentClasses = useStyles();
  return <div className={componentClasses.root}>{text}</div>;
}
